import axios from "axios";
import { baseUrlImg } from "./http";

export const uploadFile = async (file: any, type = "common") => {
  let Formdata = new FormData();
  let progress = 0;
  Formdata.append("FileName", file);
  Formdata.append("Type", type);
  const config = {
    onUploadProgress: (progressEvent: any) => {
      progress = Math.round((100 * progressEvent.loaded) / progressEvent.total);
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(baseUrlImg, Formdata, config);
    if (response.status === 200)
      return { data: response.data, progress: progress, err: null };
    else return { err: "Image could not uploaded", data: null };
  } catch (error) {
    return { err: "Something went wrong", data: null };
  }
};
